import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSaleOrders(ctx, queryParams) {
      console.log('queryOrder order', queryParams)
      const payload = {
        "pagination": {
        "total": 0,
        "current": 0,
        "pageSize": 0
        },
        "search": {
        "name": "",
        "startPrice": null,
        "endPrice": null,
        "shopId": null,
        "categoryId": null
        },
        "sort": {
        "predicate": "",
        "reverse": true
        }
        }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/GetOrderList` , payload)
          .then(response => {
            console.log('ressearch', queryParams)
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'saleOrderId',
              sortDesc = false,
            } = queryParams
            let dataFromAPI = response.data.data

            if (q !== '' && q !== null) {
              const queryLowered = q.toLowerCase()
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                const contactNo = x.contactNo || ''
                const fullName = x.fullName || ''
                const phone = x.phone || ''
                const email = x.email || ''


                if (contactNo.toString().toLowerCase().includes(queryLowered)
                || fullName.toString().toLowerCase().includes(queryLowered)
                || phone.toString().toLowerCase().includes(queryLowered)
                || email.toString().toLowerCase().includes(queryLowered)
                ) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }



            console.log('res2', dataFromAPI)
            const sortedData = dataFromAPI.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()
            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: dataFromAPI.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchSaleOrder(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/SaleOrder/GetById`, {
            params: {
              saleOrderId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSaleOrder(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
